import { ConsignmentStockOutDetailPage } from "@/features/consignment-stockout/pages/ConsignmentStockOutDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-stockout/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["consignment_stock_out.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ConsignmentStockOutDetailPage,
});
